export const VILLA2_BLUE = "#6CAFDF";
export const VILLA2_BLUE_LIGHT = "#6caedf4d";
export const VILLA2_HOVER_BLUE = "#0086E7";
export const VILLA2_DARK_BLUE = "rgba(33, 36, 48, 1)";
